import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SessionSummaryFieldsFragment } from '../../../../../../../../../../generated/core-api/graphql-react-query';
import withSessionDetailsSectionErrorBoundary from '../SessionDetailsSectionErrorBoundary';
import RunItem from './Components/RunItem';
import StyledBox from './styles';

interface SessionDecisionTreeRunsProps {
  session: SessionSummaryFieldsFragment;
}

function SessionDecisionTreeRuns(props: SessionDecisionTreeRunsProps) {
  const { session } = props;
  const { t } = useTranslation('session');

  const filteredRuns = session.decisionTreeRuns.filter((run) => !run.parentId);
  if (filteredRuns.length === 0) {
    return null;
  }

  return (
    <StyledBox>
      <Typography variant="subtitle1">
        {t('details.decision-tree-runs.title')}
      </Typography>
      {filteredRuns.map((run) => (
        <RunItem key={run.id} run={run} />
      ))}
    </StyledBox>
  );
}

export default withSessionDetailsSectionErrorBoundary(SessionDecisionTreeRuns, 'session decision tree runs');
